import ReferEarnComp from "./component";

import { useState } from "react";

import {  toast } from 'react-toastify';
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { API_BASE_URL } from "../../config";
const ReferEarnContainer=(props)=>{
  const { makeApiRequest } = useApiRequest()

  const [earnModal, setEarnModal] = useState(false);
  const [referCode,setReferCode]=useState(null)


  const handleReferCode=(e)=>{

    //console.log("input refer code --",e.target.value)

    setReferCode(e.target.value);



  }


  const ApplyReferCode=()=>{
    if(referCode&&referCode.length>3){
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");




      
    makeApiRequest({
    
    url: `${API_BASE_URL}/auth/verify/referral/code`,
     method: "POST",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": localStorage.getItem("uuid"),
    },
    data:{       request:{
            
            "referCode":referCode
          
          
          }},
     handleSuccess: (res) => handleResponseApplyReferCode(res),
         handleError: (res) => handleErrorApplyReferCode
  });
    }
    else{

       
  toast.error("Enter Refer Code", {
    position: "top-right",
    autoClose: 1000,
});
    }
}


const handleErrorApplyReferCode=(err)=>{
 
  toast.error(`${err&&err.response&&err.response.data.statusMessage}`, {
    position: "top-right",
    autoClose: 1000,
});
}

const handleResponseApplyReferCode=(res)=>{

  ///console.log("Error",res.data)
  
  toast.error(`${res&&res.data&&res.data.statusMessage}`, {
    position: "top-right",
    autoClose: 1000,
});

}


    return(<>
    
    
    <ReferEarnComp earnModal={earnModal} setEarnModal={setEarnModal} handleReferCode={handleReferCode} ApplyReferCode={ApplyReferCode}/>
    
    </>)
}


  
  export default ReferEarnContainer
